import React, { SyntheticEvent } from 'react';
import withStyles from 'react-jss';
import { useQuery, useApolloClient } from '@apollo/react-hooks';
import { DocumentNode } from 'graphql';
import { pathOr } from 'ramda';

import FormSelect from 'components/FormSelect';
import { ClassProp } from 'helpers/types';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    margin: 'auto 0',
    paddingBottom: '5px',
  },
  filterSelect: {
    margin: '0 !important',
    '& div': {
      '&.ui.selection.dropdown': {
        padding: '.67857143em 1em !important',
        fontSize: '1rem !important',
        minWidth: '12rem !important',
        lineHeight: '1.21428571em',
        '& .default.text': {
          color: 'rgba(0, 0, 0, .25) !important',
        },
      },
    },
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
  filtersQuery: DocumentNode;
  apolloCacheKey: string;
  options: Array<Record<string, unknown>>;
  label: string;
  placeholder: string;
};

const HeaderSelectFilter = ({
  classes,
  filtersQuery,
  apolloCacheKey,
  options,
  label,
  placeholder,
}: Props) => {
  const client = useApolloClient();
  const filterPayload = useQuery(filtersQuery);

  if (filterPayload.loading) return null;

  const filterValue = pathOr('', ['data', apolloCacheKey], filterPayload);
  const handleSelectChange = (
    _: SyntheticEvent<HTMLElement, Event>,
    { value }: { value: string },
  ) => client.writeData({ data: { [apolloCacheKey]: value } });

  return (
    <div className={classes.container}>
      <p className={classes.label}>{label}</p>
      <FormSelect
        className={classes.filterSelect}
        placeholder={placeholder}
        clearable
        options={options}
        onChange={handleSelectChange}
        value={filterValue}
      />
    </div>
  );
};

export default withStyles(styles)(HeaderSelectFilter);
